import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useOutletContext } from 'react-router-dom';

import Allowed from 'components/shared/Permissions/Allowed';
import Tabs from 'components/shared/Tabs/Tabs';

const TABS_DATA = [
  {
    label: `Medications`,
    path: 'medications',
    end: true
  }
];

export default function PatientHistory(props) {
  const outletContext = useOutletContext();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const segments = pathname.split('/');
  const lastSegment = segments[segments.length - 1];

  const { patient } = props?.patient ? props : outletContext;

  useEffect(() => {
    if (lastSegment === 'history') {
      navigate('medications', { replace: true });
    }
  }, [pathname]);

  return (
    <Allowed
      requiredPermissions="patients_medical_history.read"
      customMessage={`You don't have necessary permissions to view this page.`}
      showIllustration={true}
      showMessage>
      <Tabs tabsData={TABS_DATA} theme="secondary" className="w-full items-center border-0" />
      <Outlet context={{ patient }} />
    </Allowed>
  );
}
